export default "__VITE_ASSET__DOA7B7KU__"